export default __webpack_public_path__ + "media/src/assets/images/LinehaulTransfer-78e580a8a2b165d3ec2cb6e2cc7a1d0b.svg";